import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Legend, Series, Size } from "devextreme-react/pie-chart";
import { AprEocTabD as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEocTabD = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const maleField = () => {
    const propertyName = pn<AprResponseModel>("male");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.male} {formatPercentTotal(props.data?.male, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const femaleField = () => {
    const propertyName = pn<AprResponseModel>("female");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.female} {formatPercentTotal(props.data?.female, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const nonBinaryField = () => {
    const propertyName = pn<AprResponseModel>("nonBinary");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.nonBinary} {formatPercentTotal(props.data?.nonBinary, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const unknownField = () => {
    const propertyName = pn<AprResponseModel>("unknownGender");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    const style = props.data?.unknownGender != 0 ? { color: "red" } : {};

    return (
      <DataDisplay label={property?.displayName} style={style}>
        {props.data?.unknownGender} {formatPercentTotal(props.data?.unknownGender, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
        {props.totalTabA != props.data?.totalParticipants && (
          <Typography color="error" variant="caption">
            Your Total Participants does not equal Total Participants in section A
          </Typography>
        )}
      </Stack>
    );
  };

  // const totalSecondaryParticipantsField = () => {
  //   const propertyName = pn<AprResponseModel>("totalParticipantsSecondary");
  //   const property = props.properties?.find((x) => x.propertyName === propertyName);

  //   return (
  //     <Stack direction="column">
  //       <DataDisplay label={property?.displayName}>{props.data?.totalParticipantsSecondary}</DataDisplay>
  //       {props.totalTabA != props.data?.totalParticipantsSecondary && (
  //         <Typography color="error" variant="caption">
  //           Your Total Participants does not equal Total Participants in section A
  //         </Typography>
  //       )}
  //     </Stack>
  //   );
  // };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Participant Distribution by Gender</Typography>
        <Grid container spacing="lg">
          <Grid item xs={6}>
            <Grid container spacing="lg">
              <Grid item xs={11}>
                {maleField()}
              </Grid>
              <GridBreak />

              <Grid item xs={11}>
                {femaleField()}
              </Grid>
              <GridBreak />

              <Grid item xs={11}>
                {nonBinaryField()}
              </Grid>
              <GridBreak />

              <Grid item xs={11}>
                {unknownField()}
              </Grid>
              <GridBreak />

              <Grid item xs={11}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

          <GridBreak />

          <Grid item xs={6}>
            <PieChart
              id="pie-tab-d"
              dataSource={props.data?.chartValues}
              palette="Bright"
              title="Participants"
              width="100%"
              size={{ width: 600, height: 600 }} // Increase chart size
            >
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid>

          {/* <Grid item xs={6}>
            <PieChart
              id="pie-tab-d-2"
              dataSource={props.data?.chartValuesSecondary}
              palette="Bright"
              title="Participants (All)"
              width="100%"
              size={{ width: 600, height: 600 }} // Increase chart size
            >
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid> */}
        </Grid>
      </Stack>
    </Card>
  );
};
